import * as Types from '../types/provider';

export const activateLoadingStatus = (payload) => ({
    type    : Types.ACTIVATE_LOADING_STATUS,
    payload : payload
});

export const deactivateLoadingStatus = (payload) => ({
    type    : Types.DEACTIVATE_LOADING_STATUS,
    payload : payload
});

export const changeUIDisplayLanguage = (payload) => ({
    type        : Types.CHANGE_UI_DISPLAY_LANGUAGE,
    payload     : payload
});